export default function () {
    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.9165 20C16.9165 21.3807 18.0358 22.5 19.4165 22.5C20.7972 22.5 21.9164 21.3807 21.9164 20C21.9164 18.6193 20.7972 17.5 19.4165 17.5C18.0358 17.5 16.9165 18.6193 16.9165 20ZM20.4555 20.017C20.4555 20.5693 20.0078 21.017 19.4556 21.017C18.9033 21.017 18.4556 20.5693 18.4556 20.017C18.4556 19.4647 18.9033 19.017 19.4556 19.017C20.0078 19.017 20.4555 19.4647 20.4555 20.017Z"
                fill="white"
            ></path>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.9165 20C6.9165 21.3807 8.03578 22.5 9.41647 22.5C10.7972 22.5 11.9164 21.3807 11.9164 20C11.9164 18.6193 10.7972 17.5 9.41647 17.5C8.03578 17.5 6.9165 18.6193 6.9165 20ZM10.4555 20.017C10.4555 20.5693 10.0078 21.017 9.45555 21.017C8.90328 21.017 8.45557 20.5693 8.45557 20.017C8.45557 19.4647 8.90328 19.017 9.45555 19.017C10.0078 19.017 10.4555 19.4647 10.4555 20.017Z"
                fill="white"
            ></path>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.9164 6.66667H8.19731L7.93443 4.67432C7.77155 3.432 6.71318 2.5019 5.45956 2.5H3.58332C3.12309 2.5 2.75 2.8731 2.75 3.33333C2.75 3.79357 3.12309 4.16667 3.58332 4.16667H5.45829C5.87491 4.1673 6.2277 4.47733 6.28202 4.89167L7.54876 14.4923C7.71283 15.7441 8.7855 16.6774 10.0486 16.6666L18.8498 16.6667C20.0446 16.6897 21.0979 15.8418 21.3338 14.654L22.7335 7.66362C22.8368 7.1479 22.4423 6.66667 21.9164 6.66667ZM9.20095 14.275L8.41699 8.33331H20.8994L19.6991 14.328C19.6202 14.7252 19.2691 15.0079 18.8655 15.0001L10.0413 15C9.61323 15.0036 9.25568 14.6925 9.20095 14.275Z"
                fill="white"
            ></path>
            <path
                d="M15.25 9.5C15.25 9.22386 15.0261 9 14.75 9C14.4739 9 14.25 9.22386 14.25 9.5V11H12.75C12.4739 11 12.25 11.2239 12.25 11.5C12.25 11.7761 12.4739 12 12.75 12H14.25V13.5C14.25 13.7761 14.4739 14 14.75 14C15.0261 14 15.25 13.7761 15.25 13.5V12H16.75C17.0261 12 17.25 11.7761 17.25 11.5C17.25 11.2239 17.0261 11 16.75 11H15.25V9.5Z"
                fill="white"
                stroke="white"
                strokeWidth="0.3"
            ></path>
        </svg>
    );
}
